import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M17 1.01 7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 18H7V6h10v12zm-6.66-3.71c.39.39 1.02.39 1.41 0l3.54-3.54c.39-.39.39-1.02 0-1.41a.9959.9959 0 0 0-1.41 0l-2.83 2.83-.71-.71a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l1.41 1.42z"
}), 'SystemSecurityUpdateGoodRounded');